import { SOFTPHONE_ROLES, _broadcastState } from '@/store/modules/softphone.store'

/**
 * Broadcasts the owner's softphone state to every dashboard tab.
 *
 * This is a mutation subscriber rather than a `channel.postState()` at the end of each action
 * deliberately: the set of actions that move the state machine grows (answer, hang up, wrap-up
 * expiry, transport errors, a lost tab claim), and a single missed call site would leave the
 * campaigns list showing a stale button forever. Subscribing to the mutations makes that
 * impossible to forget.
 *
 * `APPLY_REMOTE_STATE` is skipped for the obvious reason - rebroadcasting what we were just told
 * would be an echo. It can only ever run on a mirror anyway, which never broadcasts.
 */
export const NON_BROADCAST_MUTATIONS = ['softphone/APPLY_REMOTE_STATE', 'softphone/SET_ROLE']

export default function softphoneSyncPlugin(store) {
  store.subscribe(mutation => {
    if (!mutation.type.startsWith('softphone/')) {
      return
    }

    if (NON_BROADCAST_MUTATIONS.includes(mutation.type)) {
      return
    }

    if (store.state.softphone.role !== SOFTPHONE_ROLES.OWNER) {
      return
    }

    _broadcastState(store.state.softphone)
  })
}
